/**
 *    ABOUT STYLE CONTROLLER
 *    all app styles can be seen here, no data is used
 */
import React, { useState, useEffect, useRef, MouseEvent } from 'react';
import { ngContext } from '../../core/services/ng.delegate';
import { StyleColorsTab, StyleIconsTab, StyleFormTab } from './ui/styleTabs';
import PageTop from '../../core/components/PageTop';
import TableList from '../../core/table/TableList';

enum Render {
    INIT = 'INIT',
    COLORS = 'COLORS',
    ICONS = 'ICONS',
    CLICKABLES = 'CLICKABLES',
    FORM = 'FORM',
    TABLE = 'TABLE',
}

type Store = {
    hasUser: boolean;
};

const AboutStyleCtl = (): JSX.Element => {
    const _store = useRef<Store>({
        hasUser: false,
    });
    const [_render, setRender] = useState<Render>(Render.INIT);

    // INIT
    useEffect(() => {
        const store = _store.current;
        store.hasUser = !!ngContext().User;
        setRender(Render.COLORS);
    }, []);

    function tabChange(e: MouseEvent, newTab: Render): void {
        e.preventDefault();
        setRender(newTab);
    }

    // RENDER

    const TabItem = ({ tabId }: { tabId: Render }): JSX.Element => {
        const hasFocus = _render == tabId ? 'has-focus' : '';
        const title = tabId as string;
        return (
            <li
                className={hasFocus}
                onClick={e => tabChange(e, tabId)}
            >
                {title}
            </li>
        );
    };
    const TabBar = (): JSX.Element | null => {
        if (_render == Render.INIT) {
            return null;
        }

        return (
            <section className="tab-bar">
                <ul>
                    <TabItem tabId={Render.COLORS} />
                    <TabItem tabId={Render.ICONS} />
                    <TabItem tabId={Render.CLICKABLES} />
                    <TabItem tabId={Render.FORM} />
                    <TabItem tabId={Render.TABLE} />
                </ul>
            </section>
        );
    };

    const ClickablesTab = (): JSX.Element => {
        return (
            <div className="tab-panel style-clickables">
                <h6>BUTTONS</h6>
                <p>
                    <button>Primary Action</button>
                    <span>
                        <button className="btn-alt">Secondary Action</button>
                    </span>
                    <span>
                        <button className="btn-cancel">Cancel</button>
                    </span>
                    <span>
                        <button className="btn-delete">Delete</button>
                    </span>
                    <span>
                        {/* eslint-disable-next-line react/no-unknown-property */}
                        <button ng-disabled="true">Disabled</button>
                    </span>
                </p>
                <p>&nbsp;</p>
                <h6>LINKS</h6>
                <p>
                    <span>
                        <a>Click Me</a>
                    </span>
                    <span>
                        <a>
                            <span className="icon-glyph icon-ce"></span>Click Me With Icon
                        </a>
                    </span>
                    <span>
                        <a>
                            Expand<span className="icon-glyph icon-down"></span>
                        </a>
                    </span>
                    <span>
                        <a>
                            Collapse<span className="icon-glyph icon-up"></span>
                        </a>
                    </span>
                </p>
            </div>
        );
    };

    const TableTab = (): JSX.Element => {
        return (
            <div className="tab-panel style-table">
                <div className="panel-top-right">
                    <a className="help-text-link">help link panel top right</a>
                </div>
                <TableList>
                    <div className="table-popup-top">
                        {/* TABLE TITLE */}
                        <div className="table-list-title">
                            <span className="title-left">Viewing x of x items</span>
                            <div className="title-right">
                                <a>
                                    <span className="icon-glyph icon-pdf"></span>Save to Excel Link
                                </a>
                                <button
                                    className="btn-alt"
                                    type="button"
                                >
                                    CREATE
                                </button>
                            </div>
                        </div>
                        {/* TABLE */}
                        <div className="table-fixed-header-scroll">
                            <table>
                                <thead className="fixed-header">
                                    {/* SECTIONS */}
                                    <tr>
                                        <th>Column Section Title</th>
                                        <th colSpan={2}>Column Section Title</th>
                                    </tr>
                                    {/* TITLES */}
                                    <tr className="column-titles">
                                        <td>
                                            <a>Clickable title name for sorting</a>
                                        </td>
                                        <td>
                                            <a>Clickable title name for sorting</a>
                                        </td>
                                        <td>
                                            <a>Clickable title name for sorting</a>
                                        </td>
                                    </tr>
                                    {/* FILTERS */}
                                    <tr className="column-filters">
                                        <td>Textbox or dropdown to filter rows</td>
                                        <td>
                                            <input type="text" />
                                        </td>
                                        <td>
                                            <input type="text" />
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="table-list-item">
                                        <td colSpan={3}>Repeating table rows</td>
                                    </tr>
                                    <tr className="table-list-item">
                                        <td>col 1</td>
                                        <td>col 2</td>
                                        <td>col 3</td>
                                    </tr>
                                    <tr className="table-list-item row-shade">
                                        <td>col 1</td>
                                        <td>col 2</td>
                                        <td>col 3</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* PAGING */}
                        {/* eslint-disable-next-line react/no-unknown-property */}
                        <div widget-paging></div>
                        {/* POPUP
						<div className="table-popup">
							<div id="featurePopupContent" className="table-popup-content">
								<h5 className="table-popup-title">Popup Title</h5>
								<p>Popup Content...</p>
							</div>
							<div className="table-popup-bkg">&nbsp;</div>
						</div>
						*/}
                    </div>
                </TableList>
            </div>
        );
    };

    const TabPanel = (): JSX.Element | null => {
        switch (_render) {
            case Render.COLORS:
                return <StyleColorsTab />;
            case Render.ICONS:
                return <StyleIconsTab />;
            case Render.CLICKABLES:
                return <ClickablesTab />;
            case Render.FORM:
                return <StyleFormTab />;
            case Render.TABLE:
                return <TableTab />;
            default:
                return null;
        }
    };

    // RENDER MAIN
    return (
        <>
            <PageTop
                title="Style"
                icon="icon-style"
            />
            <div className="style-feature">
                <TabBar />
                <TabPanel />
            </div>
        </>
    );

    // HELPERS
};

export default AboutStyleCtl;
